// @ts-nocheck
import { LINK_VIDEO } from "constants/common";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { urlAssetsCustom } from "utils/common";
import { useEffect } from "react";
const PopupImage = (props) => {
  useEffect(() => {
    console.log("props?.contentCard", props?.contentCard);
  }, [props?.contentCard]);
  return (
    <>
      <div
        className="popup-overlay modal-image"
        className={`${
          props?.contentCard?.urlImg
            ? "popup-overlay modal-image "
            : "popup-overlay modal-image mbphoto"
        }`}
      >
        <div className="popup-warp">
          <div className="close-modal" onClick={props.closeModalImage}></div>
          <div className="cardWrapper">
            <div className="content-image">
              <img
                className="logoCard"
                src={urlAssetsCustom("assets/img/logoCard.png")}
              />
              <div className="nameSend">
                <h3>
                  Đến{" "}
                  <span>
                    {props?.contentCard?.receiverName || "Gửi mẹ kính yêu"}
                  </span>
                </h3>
              </div>
              
              <p
                style={{ whiteSpace: "pre-line" }}
                dangerouslySetInnerHTML={{
                  __html: props?.contentCard?.content,
                }}
              ></p>
              <img
                className="spCard"
                src={urlAssetsCustom("assets/img/sp.png")}
              />
            </div>
            <div className="image-card">
              {!props?.contentCard?.urlImg ? (
                <img
                  src={props?.contentCard?.imageUrl}
                  alt={props?.contentCard?.imageUrl}
                />
              ) : (
                <img
                  src={props?.contentCard?.imageUrl}
                  alt={props?.contentCard?.imageUrl}
                />
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default PopupImage;
